import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[pcsModalHost]',
})
export class ModalHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
